module.exports = __webpack_public_path__ + "img/butter_chicken_prep.58164082.jpg";